/**
 * 목록 PDF/Excel 내보내기 — 8개 목록 페이지(suit/advice/client/work/collecting/document/purchase/timesheet)가
 * 각자 들고 있던 downloadExport() + 모달 상태를 통합(2026-09-14 C-H5). 모달 마크업은 fragments/export-modal.html.
 *
 * 사용: <div class="contents" x-data="exportDownload({ endpoint: '/suit/api/export', formId: 'suitSearchForm', fallback: '소송리스트' })">
 *        [PDF 버튼] [Excel 버튼] <th:block th:replace="~{fragments/export-modal :: exportModals(${page.numberOfElements})}"/>
 *      </div>
 *  - endpoint: '.pdf' | '.xlsx' 를 붙여 GET
 *  - formId  : 검색 폼 — 모든 필드를 **빈값 포함** 그대로 전송(목록 GET 재현. 빈 status 를 빼면 서버 기본값으로 잘못 해석됨)
 *  - fallback: Content-Disposition 파싱 실패 시 파일명 접두어
 * current 모드는 URL 의 page/size 를 승계. 완료 시점을 알기 위해 current 도 fetch→blob(2026-08-27).
 * 400(행수 초과)/503(렌더 슬롯) 은 서버 JSON message 를 토스트로.
 */
export default (opts = {}) => ({
    pdfModalOpen: false,
    excelModalOpen: false,
    exporting: false,
    _endpoint: opts.endpoint || '',
    _formId: opts.formId || '',
    _fallback: opts.fallback || '내보내기',

    toast(type, title, message) {
        window.dispatchEvent(new CustomEvent('show-toast', { detail: { type, title, message } }));
    },

    // fmt: 'pdf' | 'xlsx', mode: 'current' | 'all'
    downloadExport(fmt, mode) {
        if ((fmt !== 'pdf' && fmt !== 'xlsx') || (mode !== 'current' && mode !== 'all')) return;
        const label = (fmt === 'pdf') ? 'PDF' : 'Excel';
        const endpoint = this._endpoint + '.' + fmt;
        const params = new URLSearchParams();
        const form = this._formId ? document.getElementById(this._formId) : null;
        if (form) {
            for (const [k, v] of new FormData(form).entries()) params.append(k, v);
        }
        params.set('mode', mode);
        if (mode === 'current') {
            const urlParams = new URLSearchParams(location.search);
            if (urlParams.has('page')) params.set('page', urlParams.get('page'));
            if (urlParams.has('size')) params.set('size', urlParams.get('size'));
        }
        if (this.exporting) return;
        this.exporting = true;
        this.pdfModalOpen = false;
        this.excelModalOpen = false;
        fetch(endpoint + '?' + params.toString())
            .then(async (res) => {
                if (res.ok) {
                    const blob = await res.blob();
                    const cd = res.headers.get('content-disposition') || '';
                    const m = cd.match(/filename\*=UTF-8''([^;]+)/i);
                    const filename = m ? decodeURIComponent(m[1]) : (this._fallback + '_전체.' + fmt);
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url; a.download = filename;
                    document.body.appendChild(a); a.click(); a.remove();
                    URL.revokeObjectURL(url);
                    return;
                }
                let msg = label + ' 생성에 실패했습니다.';
                try { const j = await res.json(); if (j && j.message) msg = j.message; } catch (e) {}
                this.toast('warning', '알림', msg);
            })
            .catch(() => this.toast('error', '오류', label + ' 다운로드 중 오류가 발생했습니다.'))
            .finally(() => { this.exporting = false; });
    }
});
